export class Collection {
  entityID: string;
  collectionID: string; 
  action: string; 
}